import { createContext } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  username: null,
  authToken: null,
  socket: null,
  login: () => {},
  logout: () => {}
});
